import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import {
  fetchTopics,
  getRandomAthletes,
} from "../store/actions/athleteActions";
import { Link } from "react-router-dom";
import { useState } from "react";

const LearnWithExpertAthlete = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  let { randomAthletes, topics } = useSelector((state) => state.athlete);
  useEffect(() => {
    dispatch(getRandomAthletes());
    dispatch(
      fetchTopics(() => {
        setLoader(true);
      })
    );
  }, []);

  return (
    <>
      <Container fluid>
        <div className="py-4 px-1 px-sm-4">
          <Link to="/home-for-athlete">
            <Button color="primary">Back</Button>
          </Link>
        </div>
      </Container>
      <Container className="term-and-condition-main">
        <Row>
          <Col sm={12}>
            <h2 className="terms-title px-2 px-sm-3">
              <u>
                Athletes be aware -OPTIONS FOR LESSONS FROM WHICH Fans can
                choose for you to teach them in chat. Fans are instructed as
                follows:Post Question,then a)Search Athlete Available Database
                or b)Find Your Choice of athlete Profile and Email your QUESTION
                ID to their email address.
              </u>
            </h2>
            <div className="my-4">
              {loader ? (
                <Row>
                  <Col xs={12} md={7} lg={8}>
                    <div>
                      <ol type="1">
                        {topics &&
                          topics?.map((topic) => {
                            return (
                              <li className="termsPoint">
                                <p>
                                  {topic?.name}
                                  <a
                                    href={topic?.link}
                                    target="_blank"
                                    className="mx-2"
                                  >
                                    {topic?.link ? topic?.link : ""}
                                  </a>
                                </p>
                              </li>
                            );
                          })}
                      </ol>
                    </div>
                  </Col>
                  <Col xs={12} md={5} lg={4}>
                    <Row>
                      {randomAthletes.map((ath, index) => {
                        return (
                          <Col
                            xs={12}
                            md={11}
                            lg={10}
                            align="center"
                            key={index}
                          >
                            <Card className="filter-card my-3">
                              <CardBody className="custom-card-body">
                                <img
                                  className="random-avatar"
                                  alt="Card avatar cap"
                                  src={ath.player_image.url}
                                />
                                <h5>{ath.first_name + " " + ath.last_name}</h5>
                                <small class="email">{ath.email}</small>
                              </CardBody>
                            </Card>
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
              ) : (
                <div className="text-center">
                  <div className="spinner-border text-dark" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default LearnWithExpertAthlete;
